import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "nda-creation"
    }}>{`NDA Creation`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`In business, it is often necessary for a company to create and then have another organization sign a non-disclosure agreement (NDA). The specific information required to customize the document is most likely already in a database or might be submitted in a web app. In addition, other items, such as logos, need to be applied. For many, the current method of creating these customized NDAs and then sending them out to be signed is a manual, slow process.`}</p>
    <p>{`With Adobe Acrobat Services, companies can:`}</p>
    <ul>
      <li parentName="ul">{`Develop a standard, branded NDA template`}</li>
      <li parentName="ul">{`Merge data from a specific company with the template to create a customized NDA`}</li>
      <li parentName="ul">{`Send the NDA out for signatures`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A company has a standard NDA template that they regularly use for vendor agreements. They populate the NDA with data that is referenced in their CRM to customize the document, including contact name, company location, agreement scope, and dates. Once the document is generated with custom data, they need to send it out for signatures and archive it.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Within the application layer, query the database to collect relevant data for a custom NDA and create a JSON data model`}</li>
      <li parentName="ol">{`Design a branded NDA in Microsoft Word`}</li>
      <li parentName="ol">{`Send the template and data to Adobe Document Generation API to output a merged PDF which can be sent using `}<a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
      <li parentName="ol">{`Track engagement and understand learning needs by using analytics events tracked in embedded PDF documents`}</li>
    </ol>
    <h3 {...{
      "id": "building-in-power-automate"
    }}>{`Building in Power Automate`}</h3>
    <p>{`A solution to this use-case can also be implemented in Power Automate by using the following Adobe connectors:`}</p>
    <ul>
      <li parentName="ul">{`Adobe PDF Services Connector (includes Document Generation)`}</li>
      <li parentName="ul">{`Adobe Acrobat Sign Connector`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      